export default {
  init() {
    this.initHandlers();
  },

  initHandlers() {
    $('#activatePopup').on('show.bs.modal', function (event) {
      const link = $(event.relatedTarget);
      const modal = $(this);
      modal.find('[data-activate="true"]').attr('href', link.attr('href'));
    });

    $('#deactivatePopup').on('show.bs.modal', function (event) {
      const link = $(event.relatedTarget);
      const modal = $(this);
      modal.find('[data-activate="false"]').attr('href', link.attr('href'));
    });

    $('#removePopup').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget);
      const modal = $(this);
      modal.find('[data-delete="true"]').attr('href', button.attr('data-href'));
      modal
        .find('.modal-title')
        .text(
          'You will delete this template. Warning: this will delete all the works using this template, are you sure?'
        );
    });
  },
};
